import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { animationDuration } from '../../styles/variables.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fRef } from '../../utils/React.js';
import { getThemeChildrenClass } from '../Theme/ThemePresentation.js';
import { mainClass } from './Dwindle.styles.js';

var clickAnimationDuration = animationDuration.double;
var defaultProps = {
  look: "primary",
  shape: "rectangular"
};
var DwindlePresentation = fRef(function (props) {
  var _cleanupClassObject;

  var children = props.children,
      ref = props.ref,
      look = props.look,
      shape = props.shape,
      hover = props.hover,
      clicked = props.clicked,
      floating = props.floating,
      disabled = props.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(mainClass), true), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__").concat(look), !disabled), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__disabled"), disabled), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__").concat(shape), !!shape), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__hover"), hover), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__clicked"), clicked), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__inner_floating"), floating), _defineProperty(_cleanupClassObject, getThemeChildrenClass("brand"), look === "primary" && !disabled), _cleanupClassObject)),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(mainClass, "-inner")
  }, children));
}, defaultProps);

export { DwindlePresentation, clickAnimationDuration };
